import { UnplugIcon } from "lucide-react";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "./empty";
import { Trans } from "@lingui/react/macro";

export default function Error({
  error,
  heading,
  description,
  className,
  hideIcon,
  ...rest
}: {
  heading?: string;
  description?: string;
  error?: Error | null;
  className?: string;
  hideIcon?: boolean;
}) {
  return (
    <Empty {...rest} className={className}>
      <EmptyHeader>
        {!hideIcon && (
          <EmptyMedia variant="icon">
            <UnplugIcon />
          </EmptyMedia>
        )}
        <EmptyTitle>{heading}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
        {error && (
          <EmptyDescription className="text-destructive select-text selection:bg-destructive selection:text-destructive-foreground">
            <Trans>Fel</Trans>: {error.message}
          </EmptyDescription>
        )}
      </EmptyHeader>
    </Empty>
  );
}
